import {
  getExternalMapUrl,
  getStaticMapUrl,
  parseLatLng,
} from "../utils/mapProvider";
import TextTranslate from "../utils/TextTranslate";

type Props = {
  lat?: number | string | null;
  lng?: number | string | null;
  content?: string | null;
  className?: string;
};

/**
 * Location bubble: Yandex static map preview.
 * Click opens Yandex Maps in a new tab.
 */
export default function LocationMapEmbed({
  lat,
  lng,
  content,
  className = "h-40 w-full",
}: Props) {
  const coords =
    lat != null && lng != null
      ? { lat: Number(lat), lng: Number(lng) }
      : parseLatLng(content);

  if (
    !coords ||
    !Number.isFinite(coords.lat) ||
    !Number.isFinite(coords.lng)
  ) {
    return (
      <div
        className={`grid place-content-center bg-black/[0.04] text-[13px] text-lightText dark:bg-white/[0.06] ${className}`}
      >
        <TextTranslate text="Location unavailable" />
      </div>
    );
  }

  const openUrl = getExternalMapUrl("yandex", coords.lat, coords.lng);
  const previewUrl = getStaticMapUrl(coords.lat, coords.lng);

  return (
    <button
      type="button"
      onClick={() => window.open(openUrl, "_blank", "noopener,noreferrer")}
      className={`relative block w-full cursor-pointer overflow-hidden bg-[#e8eef5] p-0 dark:bg-[#2a2f36] ${className}`}
      aria-label="Open location in Yandex Maps"
    >
      <img
        src={previewUrl}
        alt=""
        className="h-full w-full object-cover"
        loading="lazy"
        referrerPolicy="no-referrer"
        draggable={false}
      />
    </button>
  );
}
